import React from 'react'
import { observer } from 'mobx-react-lite'

import Card from '@mui/material/Card'
import Tab from '@mui/material/Tab'
import Tabs from '@mui/material/Tabs'

import { useGlobalCopyStore, TabContentContainer } from '../../../common'

import AvailableTabContent from './AvailableTabContent'
import LineGraph from '../shared/LineGraph'
import SpendingTabContent from './SpendingTabContent'

const SaveEnoughToLiveOnDrawerContent: React.FC = () => {
  const [tabValue, setTabValue] = React.useState(0)
  const { finstrong: copy } = useGlobalCopyStore()

  return (
    <>
      <Card>
        <Tabs
          aria-label={copy.key_indicators_save.drawer_title}
          centered={true}
          onChange={(_, val) => setTabValue(val)}
          selectionFollowsFocus={true}
          sx={{ mb: 0 }}
          value={tabValue}
          variant="fullWidth"
        >
          <Tab
            aria-controls="available-details-tabpanel-0"
            label={copy.key_indicators_save.drawer_available}
            sx={{ minHeight: 44 }}
          />
          <Tab
            aria-controls="spending-details-tabpanel-1"
            label={copy.key_indicators_save.drawer_spending}
            sx={{ minHeight: 44 }}
          />
        </Tabs>

        <TabContentContainer index={0} name="available-details" value={tabValue}>
          <AvailableTabContent />
        </TabContentContainer>

        <TabContentContainer index={1} name="spending-details" value={tabValue}>
          <SpendingTabContent />
        </TabContentContainer>
      </Card>
      <LineGraph chartFor="savingsOverTime" />
    </>
  )
}

export default observer(SaveEnoughToLiveOnDrawerContent)
